import BaseLifeCycle from './BaseLifeCycle';

class OnReady extends BaseLifeCycle {
	constructor() {
		super(true);
		if (
			document.readyState === 'complete' ||
			document.readyState === 'loaded'
		) {
			this.onEvent();
		} else {
			window.addEventListener('DOMContentLoaded', this.onEvent);
		}
	}
}

export default new OnReady();
